import { ENV } from '../const/ENV'
import { Environment } from '../const/Environment'

const baseDomains: Partial<Record<Environment, string>> = {
  [Environment.development]: '.backoffice.dev.moia-group.io',
  [Environment.integration]: '.backoffice.int.moia-group.io',
  [Environment.production]: '.backoffice.moia-group.io',
}

/**
 * Converts a full Backoffice URL to a shareable cross-organization URL.
 *
 * @param url - The full Backoffice URL to convert (must include protocol)
 * @returns The shareable URL using share.backoffice domain, or null if conversion fails
 *
 * @example
 * // Convert current page
 * const shareUrl = convertToShareUrl(window.location.href)
 *
 * // Convert specific URL
 * const shareUrl = convertToShareUrl('https://moia-ops.backoffice.moia-group.io/kpi-dashboard/chart/123?granularity=day')
 *
 * // Returns: https://share.backoffice.moia-group.io/kpi-dashboard/chart/123?granularity=day
 */
export const convertToShareUrl = (url: string): string | null => {
  const baseDomain = baseDomains[ENV]

  if (!baseDomain) {
    return null
  }

  try {
    const urlObj = new URL(url)
    return `https://share${baseDomain}${urlObj.pathname}${urlObj.search}${urlObj.hash}`
  } catch (error) {
    console.error('Failed to convert URL to share URL:', error)
    return null
  }
}
